export enum MigrationIds {
    BasicData = 'BASIC_DATA',
    EnergyPrices = 'ENERGY_PRICES'
}
